import { createTheme } from '@one-thd/sui-atomic-components';

const HouseStylePrimaryNeutralGray = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

HouseStylePrimaryNeutralGray.palette['--sui-palette-background-primary'] = '246 243 239';

export { HouseStylePrimaryNeutralGray };